export const uploadProtocolConfig = {
  heading: 'Upload Protocol',
  message: 'Select a file to upload.',
  callback: 'clickedUploadProtocolConfig',
};
